var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mers_block"},[_c('div',{staticClass:"mers_block__title"},[_vm._v("Экскурсия с инвестиционным консультантом по объектам")]),_c('button',{staticClass:"btn btn--white",on:{"click":function($event){$event.preventDefault();return _vm.openPhoneModal.apply(null, arguments)}}},[_vm._v("Пройти экскурсию")])])
}
var staticRenderFns = []

export { render, staticRenderFns }